import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

const GTM_CONTAINER_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID || 'GTM-XXXXXX'

export const analytics = Analytics({
  app: 'nrm',
  plugins: [
    googleTagManager({
      containerId: GTM_CONTAINER_ID,
      enabled: import.meta.env.PROD // Vite's built-in env for production
    })
  ]
})

// Utility functions for tracking
export const trackPageView = (url: string) => {
  if (window.gtag) {
    window.gtag('config', GTM_CONTAINER_ID, {
      page_path: url
    });
  }
}

export const trackEvent = (name: string, properties?: Record<string, unknown>) => {
  if (window.gtag) {
    window.gtag('event', name, properties);
  }
} 